import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'hr_HR',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '896fe61b-fb7e-4da0-9df8-95591b294df2',
  ''
);
